<template>

    <li class="comment-item" :style="!showActions ? 'list-style-type: none' : ''">
<!--        <transition-group name="highlight">-->
                <div
                    @key="comment.id"
                    :class="{
                'editing-comment': editingComment === comment.id,
                'system-comment' : isSystem,
                'deleted-comment': isDeleted,
                'comment-item-inner-reply': comment.parentCommentId,
                'comment-item-inner': !comment.parentCommentId,
                'highlighted-div': !!this.isHighlighted
              }">

                    <div
                        class="comment-avatar"
                        :style="{'background-color': comment.roleColor, color: comment.roleColor ? '#fff' : '#333'}">
                        <span v-if="!isSystem">{{ getInitials(comment.firstName, comment.lastName) }}</span>
                        <span v-else>MA</span>
                    </div>
                    <div class="comments-details">
                        <div class="comments-header">
                            <div>
                                <span
                                    v-if="!isSystem"
                                    class="comments-name"
                                    v-text="comment.firstName + ' ' + comment.lastName"></span>
                                <span
                                    v-else
                                    class="comments-name">System</span>
                                <span
                                    v-if="comment.originalCommentId"
                                    v-tooltip="comment.updatedAt"
                                    :title="comment.updatedAt"
                                    style="margin-right:10px;"
                                    class="comment-edited">(Edited)</span>
                            </div>
                            <span v-if="comment.fileName" v-tooltip="comment.fileName" :title="comment.fileName"
                                  class="file-id">#{{ comment.id }}</span>
                            <span class="comments-actions" :class="{ 'hidden': isFetchingFileComments }"
                                  v-if="showCommentActions()">

                        <PencilIcon
                            v-if="canEdit && showActions"
                            @click="$emit('edit', comment)"
                            fillColor="#cccccc"
                            :size="16"
                        />
                    <TrashCanIcon
                        v-if="canDelete && showActions"
                        @click="$emit('delete', comment.id)"
                        fillColor="#cccccc"
                        :size="16"
                    />
                    <Reply
                        v-if="!comment.parentCommentId && showActions"
                        @click="$emit('reply', comment)"
                        fillColor="#cccccc"
                        :size="16"
                    />
                  </span>
                        </div>
                        <span class="comments-date">{{ toDate(comment.date) }}</span>
                        <div class="comments-content">
                            <div v-if="typeof processedComment === 'string'" v-html="processedComment"></div>
                            <div v-else>
                                <span v-if="!showHiddenContent" v-html="processedComment.visibleText"></span>
                                <span v-else v-html="processedComment.hiddenText"></span>
                                <a href="#" @click.prevent="toggleReadMore()">
                                    {{ !showHiddenContent ? 'Read More' : 'Read Less' }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <slot></slot>
<!--        </transition-group-->
    </li>
</template>

<script>
import './style.scss';
import template from './template.html';
import {PencilIcon, TrashCanIcon, Reply} from '../icons.js';
import moment from "moment";

export default {

    props: {
        isReplyingToComment: {
            default: false
        },
        showActions: {
            default: true
        },
        setIsReplyingToComment: {
            type: Function,
            default() {
            }
        },
        editingComment: {
            type: [String, Number],
        },

        comment: {
            type: Object,
            required: true
        },

        canEdit: {
            type: Boolean,
            default: true
        },

        canDelete: {
            type: Boolean,
            default: true
        },

        isSystem: {
            type: Boolean,
            default: false
        },

        isDeleted: {
            type: Boolean,
            default: false,
        },

        isUnlocked: {
            type: Boolean,
            default: true
        },

        isFetchingFileComments: {
            type: Boolean,
            default: false
        },
        isHighlighted: {
            type: Boolean,
            default: false
        },
    },

    created() {
    },

    computed: {
        processedComment() {
            return this.preprocessComment(this.comment);
        }
    },

    methods: {

        /**
         * Should the comment actions be visible?
         *
         * @return {Boolean}
         */
        showCommentActions() {
            let {isUnlocked, isSystem, isDeleted} = this;

            return isUnlocked && !isSystem && !isDeleted;
        },

        toDate(date) {
            return moment(date).format('D-MMM-YYYY h:mm a')
        },

        /**
         * Get initials of users name
         *
         * @param {String} firstName
         * @param {String} lastName
         * @return String
         */
        getInitials(firstName, lastName) {
            firstName = firstName?.charAt(0).toUpperCase();
            lastName = lastName?.charAt(0).toUpperCase();

            return firstName + lastName;
        },

        preprocessComment(comment) {
            if (comment.isNotificationReply) {
                return comment.text;
            }
            
            let wordLimit = 20;
            let div = document.createElement('div');
            div.innerHTML = comment.html;
            let words = div.innerText.split(' ');
            if (words.length > wordLimit) {
                let visibleText = words.slice(0, wordLimit).join(' ');
                let hiddenText = comment.html;
                return {
                visibleText,
                hiddenText,
                showHiddenContent: true
                };
            } else {
                return div.innerHTML;
            }
        },

        toggleReadMore() {
            this.showHiddenContent = !this.showHiddenContent;
        },
    },

    template,

    data() {

        return {
            showHiddenContent: true
        };
    },

    components: {
        PencilIcon,
        TrashCanIcon,
        Reply,
    }
};
</script>
